import { useEffect } from "react";
import BestPitches from "../components/BestPitches";
import FeaturesSection from "../components/FeaturesSection";
import Hero from "../components/Hero";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="sm:mt-10">
      <Hero />
      <BestPitches />
      <FeaturesSection />
    </div>
  );
}

export default Home;
